import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoImg from '../assets/images/stations.svg';
import { Box, Typography } from '@mui/material';

const Logo = () => {
    const navigate = useNavigate();

    return (
        <Box
            display={'flex'}
            onClick={() => navigate('/')}
            sx={{
                cursor: 'pointer',
                '&:hover': {
                    opacity: 0.8
                }
            }}
        >
            <Box component="img" src={LogoImg} width="50px" alt="stations"></Box>
            <Typography sx={{ lineHeight: '1.7em' }} variant="h3">
                stations
            </Typography>
        </Box>
    );
};

export default Logo;
